var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.cmps,"item-value":"id","item-text":"value","label":"Statut de conformité","hide-details":"","single-line":""},model:{value:(_vm.cmp),callback:function ($$v) {_vm.cmp=$$v},expression:"cmp"}})
}
var staticRenderFns = []

export { render, staticRenderFns }